export default __webpack_public_path__ + "static/media/five.8276719d.jpg";